import React from 'react';
import './AboutPage.css';

import Navigation from '../../Shared/Navigation/Navigation';
// import FindLocation from '../../PageCompos/Contact/FindLocation/FindLocation';
import Footer from '../../Shared/Footer/Footer';
import AboutUs from '../../PageCompos/About/AboutUs/AboutUs';
// import Menu from '../../PageCompos/Home/Menu/Menu';

const AboutPage = () => {
    return (
        <>
            <Navigation />
            {/* <Menu /> */}
            <AboutUs />
            {/* <FindLocation /> */}
            <Footer />
        </>
    );
};

export default AboutPage;